import React, { useState, useRef, useEffect, useContext } from "react";
import { getData, postData, serverURL } from "../../../../services/Fetchnodeservices";
// ⚠️ IMPORTANT: Adjust this path to exactly match where your ThemeContext is located!
import { ThemeContext } from "../../../../context/ThemeContext"; 

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const SearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const PlusIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const EyeIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const DeleteIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const HideIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const ShowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const UploadIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const ZoomInIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
    <line x1="11" y1="8" x2="11" y2="14" />
    <line x1="8" y1="11" x2="14" y2="11" />
  </svg>
);

// ─────────────────────────────────────────────────────────────────────────────
// IMAGE PREVIEW MODAL
// ─────────────────────────────────────────────────────────────────────────────
const ImagePreviewModal = ({ isOpen, imageUrl, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: "rgba(0,0,0,0.9)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        padding: "20px",
      }}
      onClick={onClose}
    >
      <button
        style={{
          position: "absolute", top: "20px", right: "20px",
          background: "rgba(255,255,255,0.2)", border: "none", borderRadius: "50%",
          width: "50px", height: "50px", cursor: "pointer", color: "#fff",
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "all 0.3s",
        }}
        onClick={onClose}
        onMouseEnter={(e) => (e.target.style.background = "rgba(255,255,255,0.3)")}
        onMouseLeave={(e) => (e.target.style.background = "rgba(255,255,255,0.2)")}
      >
        <CloseIcon />
      </button>
      <img
        src={imageUrl}
        alt="Preview"
        style={{
          maxWidth: "90%", maxHeight: "90vh", objectFit: "contain",
          borderRadius: "8px", boxShadow: "0 25px 60px rgba(0,0,0,0.5)",
        }}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// STATUS BADGE (Theme integrated with dynamic opacity)
// ─────────────────────────────────────────────────────────────────────────────
const StatusBadge = ({ status, hide, theme, isDark }) => {
  let label = "Active";
  let color = theme.success;
  let bg = isDark ? "rgba(34,197,94,0.2)" : "rgba(34,197,94,0.12)";

  if (hide === 1) {
    label = "Hidden";
    color = theme.textMuted;
    bg = isDark ? "rgba(148,163,184,0.2)" : "rgba(148,163,184,0.12)";
  } else if (status === 0) {
    label = "Inactive";
    color = theme.danger;
    bg = isDark ? "rgba(239,68,68,0.2)" : "rgba(239,68,68,0.12)";
  }

  return (
    <span style={{
      display: "inline-block", padding: "4px 10px", borderRadius: "20px",
      fontSize: "11px", fontWeight: 600, background: bg, color: color,
    }}>
      {label}
    </span>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// IMAGE PLACEHOLDER
// ─────────────────────────────────────────────────────────────────────────────
const ImagePlaceholder = ({ imageUrl, type, onImageClick, theme }) => {
  const getImageUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("http")) return url;
    return `${serverURL}/public/uploadnew/upload/${url}`;
  };

  const imageSrc = getImageUrl(imageUrl);

  return (
    <div
      style={{
        width: "50px", height: "50px", borderRadius: "8px",
        background: theme.background, display: "flex", alignItems: "center",
        justifyContent: "center", fontSize: "20px", border: `1px solid ${theme.border}`,
        overflow: "hidden", position: "relative", cursor: imageSrc ? "pointer" : "default",
        transition: "transform 0.2s, box-shadow 0.2s",
      }}
      onClick={() => imageSrc && onImageClick(imageSrc)}
      onMouseEnter={(e) => {
        if (imageSrc) {
          e.currentTarget.style.transform = "scale(1.05)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.2)";
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {imageSrc ? (
        <>
          <img
            src={imageSrc}
            alt={type}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            onError={(e) => {
              e.target.style.display = "none";
              e.target.parentElement.innerHTML = type === "main" ? "🖼️" : "🔘";
            }}
          />
          <div
            style={{
              position: "absolute", bottom: 0, left: 0, right: 0,
              background: "linear-gradient(to top, rgba(0,0,0,0.6), transparent)",
              padding: "4px", display: "flex", justifyContent: "center",
              opacity: 0, transition: "opacity 0.3s",
            }}
            className="image-hover-overlay"
          >
            <span style={{ color: "#fff", fontSize: "10px", fontWeight: 500 }}>
              <ZoomInIcon />
            </span>
          </div>
        </>
      ) : type === "main" ? (
        "🖼️"
      ) : (
        "🔘"
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// ADD/EDIT DIALOG
// ─────────────────────────────────────────────────────────────────────────────
const AddChooseUsDialog = ({ onClose, onSave, editingItem, theme, isDark }) => {
  const [formData, setFormData] = useState({
    title: editingItem?.title || "",
    title2: editingItem?.title2 || "",
    description: editingItem?.description || "",
    button_name: editingItem?.button_name || "",
    button_link: editingItem?.button_link || "",
    status: editingItem?.status !== undefined ? editingItem.status : 1,
    hide: editingItem?.hide !== undefined ? editingItem.hide : 0,
  });
  const [picFile, setPicFile] = useState(null);
  const [picPreview, setPicPreview] = useState(
    editingItem?.pic ? `${serverURL}/public/uploadnew/upload/${editingItem.pic}` : null
  );
  const [shortimageFile, setShortimageFile] = useState(null);
  const [shortimagePreview, setShortimagePreview] = useState(
    editingItem?.shortimage ? `${serverURL}/public/uploadnew/upload/${editingItem.shortimage}` : null
  );
  const [picDragActive, setPicDragActive] = useState(false);
  const [shortimageDragActive, setShortimageDragActive] = useState(false);
  const picFileInputRef = useRef(null);
  const shortimageFileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    }));
  };

  const handlePicChange = (file) => {
    if (file) {
      setPicFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setPicPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleShortimageChange = (file) => {
    if (file) {
      setShortimageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => setShortimagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handlePicFileInput = (e) => handlePicChange(e.target.files[0]);
  const handleShortimageFileInput = (e) => handleShortimageChange(e.target.files[0]);

  const handlePicDragOver = (e) => { e.preventDefault(); setPicDragActive(true); };
  const handlePicDragLeave = (e) => { e.preventDefault(); setPicDragActive(false); };
  const handlePicDrop = (e) => {
    e.preventDefault();
    setPicDragActive(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) handlePicChange(file);
  };

  const handleShortimageDragOver = (e) => { e.preventDefault(); setShortimageDragActive(true); };
  const handleShortimageDragLeave = (e) => { e.preventDefault(); setShortimageDragActive(false); };
  const handleShortimageDrop = (e) => {
    e.preventDefault();
    setShortimageDragActive(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) handleShortimageChange(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title.trim()) {
      alert("Title is required");
      return;
    }

    setLoading(true);
    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("title2", formData.title2);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("button_name", formData.button_name);
    formDataToSend.append("button_link", formData.button_link);
    formDataToSend.append("status", formData.status);
    formDataToSend.append("hide", formData.hide);
    if (picFile) formDataToSend.append("pic", picFile);
    if (shortimageFile) formDataToSend.append("shortimage", shortimageFile);
    if (editingItem) formDataToSend.append("id", editingItem.id);

    try {
      const url = editingItem ? "chooseus/update_banner" : "chooseus/add_banner";
      const response = await postData(url, formDataToSend);
      if (response.status) {
        onSave(response);
        onClose();
      } else {
        alert(response.message);
      }
    } catch (error) {
      alert(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const dialogStyles = {
    overlay: {
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.7)", display: "flex",
      alignItems: "center", justifyContent: "center", zIndex: 1000,
      backdropFilter: "blur(4px)",
    },
    dialog: {
      width: "90%", maxWidth: "600px", background: theme.surface,
      borderRadius: "20px", boxShadow: "0 25px 40px -12px rgba(0,0,0,0.4)",
      overflow: "hidden", animation: "fadeIn 0.2s ease-out",
    },
    header: {
      display: "flex", justifyContent: "space-between", alignItems: "center",
      padding: "18px 24px", borderBottom: `1px solid ${theme.border}`,
    },
    title: { fontSize: "20px", fontWeight: 700, color: theme.textPrimary, margin: 0 },
    closeBtn: {
      background: "none", border: "none", cursor: "pointer", color: theme.textMuted,
      padding: "4px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "8px",
    },
    body: { padding: "24px", maxHeight: "65vh", overflowY: "auto" },
    formGroup: { marginBottom: "20px" },
    label: { display: "block", marginBottom: "8px", fontSize: "13px", fontWeight: 600, color: theme.textSecondary },
    required: { color: theme.danger, marginLeft: "4px" },
    input: {
      width: "100%", padding: "12px 14px", background: theme.background,
      border: `1px solid ${theme.border}`, borderRadius: "12px", fontSize: "14px",
      color: theme.textPrimary, outline: "none", transition: "all 0.2s", boxSizing: "border-box",
    },
    textarea: {
      width: "100%", padding: "12px 14px", background: theme.background,
      border: `1px solid ${theme.border}`, borderRadius: "12px", fontSize: "14px",
      color: theme.textPrimary, outline: "none", transition: "all 0.2s", fontFamily: "inherit",
      resize: "vertical", minHeight: "80px", boxSizing: "border-box",
    },
    imageUploadArea: (dragActive) => ({
      border: `2px dashed ${dragActive ? theme.primary : theme.border}`,
      borderRadius: "12px", padding: "16px", textAlign: "center", cursor: "pointer",
      transition: "all 0.2s", background: dragActive ? theme.primaryLight : theme.background, marginTop: "8px",
    }),
    imagePreview: { width: "100%", maxHeight: "120px", objectFit: "cover", borderRadius: "8px", marginTop: "12px" },
    uploadIcon: { display: "flex", justifyContent: "center", marginBottom: "8px", color: theme.primary },
    uploadText: { fontSize: "13px", fontWeight: 500, color: theme.textMuted },
    uploadHint: { fontSize: "11px", color: theme.textMuted, marginTop: "4px", opacity: 0.7 },
    checkboxGroup: { display: "flex", gap: "24px", marginTop: "8px", alignItems: "center" },
    checkboxLabel: { display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", color: theme.textPrimary },
    checkbox: { width: "16px", height: "16px", cursor: "pointer", accentColor: theme.primary },
    footer: {
      display: "flex", justifyContent: "flex-end", gap: "12px", padding: "16px 24px",
      borderTop: `1px solid ${theme.border}`, background: theme.background,
    },
    cancelBtn: {
      padding: "10px 20px", background: "transparent", border: `1px solid ${theme.border}`,
      borderRadius: "10px", fontSize: "14px", fontWeight: 500, color: theme.textMuted,
      cursor: "pointer", transition: "all 0.2s",
    },
    saveBtn: {
      padding: "10px 24px", background: theme.gradient, border: "none", borderRadius: "10px",
      fontSize: "14px", fontWeight: 600, color: "#fff", cursor: "pointer", transition: "all 0.2s",
    },
  };

  return (
    <div style={dialogStyles.overlay} onClick={onClose}>
      <div style={dialogStyles.dialog} onClick={(e) => e.stopPropagation()}>
        <div style={dialogStyles.header}>
          <h3 style={dialogStyles.title}>{editingItem ? "Edit Choose Us" : "Add Choose Us"}</h3>
          <button style={dialogStyles.closeBtn} onClick={onClose}><CloseIcon /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={dialogStyles.body}>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Title <span style={dialogStyles.required}>*</span></label>
              <input type="text" name="title" style={dialogStyles.input} placeholder="Enter title" value={formData.title} onChange={handleChange} required autoFocus />
            </div>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Subtitle (Title 2)</label>
              <input type="text" name="title2" style={dialogStyles.input} placeholder="Enter subtitle" value={formData.title2} onChange={handleChange} />
            </div>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Description</label>
              <textarea name="description" style={dialogStyles.textarea} placeholder="Enter description" value={formData.description} onChange={handleChange} />
            </div>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Main Image</label>
              <div style={dialogStyles.imageUploadArea(picDragActive)} onClick={() => picFileInputRef.current?.click()} onDragOver={handlePicDragOver} onDragLeave={handlePicDragLeave} onDrop={handlePicDrop}>
                <input ref={picFileInputRef} type="file" accept="image/png, image/jpeg, image/jpg, image/webp" onChange={handlePicFileInput} style={{ display: "none" }} />
                <div style={dialogStyles.uploadIcon}><UploadIcon /></div>
                <div style={dialogStyles.uploadText}>{picPreview ? "Change Main Image" : "Upload Main Image"}</div>
                <div style={dialogStyles.uploadHint}>PNG, JPG, WebP up to 10MB</div>
                {picPreview && <img src={picPreview} alt="Main Preview" style={dialogStyles.imagePreview} />}
              </div>
            </div>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Short Image / Icon</label>
              <div style={dialogStyles.imageUploadArea(shortimageDragActive)} onClick={() => shortimageFileInputRef.current?.click()} onDragOver={handleShortimageDragOver} onDragLeave={handleShortimageDragLeave} onDrop={handleShortimageDrop}>
                <input ref={shortimageFileInputRef} type="file" accept="image/png, image/jpeg, image/jpg, image/webp, image/svg+xml" onChange={handleShortimageFileInput} style={{ display: "none" }} />
                <div style={dialogStyles.uploadIcon}><UploadIcon /></div>
                <div style={dialogStyles.uploadText}>{shortimagePreview ? "Change Short Image" : "Upload Short Image / Icon"}</div>
                <div style={dialogStyles.uploadHint}>PNG, JPG, SVG up to 5MB</div>
                {shortimagePreview && <img src={shortimagePreview} alt="Short Image Preview" style={dialogStyles.imagePreview} />}
              </div>
            </div>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Button Name</label>
              <input type="text" name="button_name" style={dialogStyles.input} placeholder="e.g., Learn More, Shop Now" value={formData.button_name} onChange={handleChange} />
            </div>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Button Link</label>
              <input type="text" name="button_link" style={dialogStyles.input} placeholder="e.g., /learn-more, /shop" value={formData.button_link} onChange={handleChange} />
            </div>
            <div style={dialogStyles.formGroup}>
              <label style={dialogStyles.label}>Settings</label>
              <div style={dialogStyles.checkboxGroup}>
                <label style={dialogStyles.checkboxLabel}>
                  <input type="checkbox" name="status" checked={formData.status === 1} onChange={(e) => setFormData((prev) => ({ ...prev, status: e.target.checked ? 1 : 0 }))} style={dialogStyles.checkbox} />
                  Active
                </label>
                <label style={dialogStyles.checkboxLabel}>
                  <input type="checkbox" name="hide" checked={formData.hide === 1} onChange={(e) => setFormData((prev) => ({ ...prev, hide: e.target.checked ? 1 : 0 }))} style={dialogStyles.checkbox} />
                  Hidden
                </label>
              </div>
            </div>
          </div>
          <div style={dialogStyles.footer}>
            <button type="button" style={dialogStyles.cancelBtn} onClick={onClose}>Cancel</button>
            <button type="submit" style={dialogStyles.saveBtn} disabled={loading}>{loading ? "Saving..." : editingItem ? "Update" : "Save"}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const ChooseUs = () => {
  // 🛡️ SAFE CONTEXT CONSUMPTION WITH FALLBACK
  const themeContext = useContext(ThemeContext);
  const isDark = themeContext?.currentTheme === 'dark';
  
  const fallbackTheme = {
    background: isDark ? "#0c1018" : "#f8fafc",
    surface: isDark ? "#141824" : "#ffffff",
    border: isDark ? "rgba(255,255,255,0.07)" : "#e2e8f0",
    textPrimary: isDark ? "#f1f5f9" : "#0f172a",
    textSecondary: isDark ? "#94a3b8" : "#64748b",
    textMuted: isDark ? "#64748b" : "#94a3b8",
    primary: "#6366f1",
    primaryLight: "rgba(99, 102, 241, 0.15)",
    primaryGradient: "linear-gradient(135deg, #6366f1, #8b5cf6)",
  };

  const brandTheme = themeContext?.theme || fallbackTheme;
  const currentTheme = themeContext?.currentTheme || (isDark ? 'dark' : 'light');
  const setCurrentTheme = themeContext?.setCurrentTheme || (() => {});
  const themeConfig = themeContext?.themeConfig || {
    red: { name: "Red", primary: "#dc2626" },
    blue: { name: "Blue", primary: "#2563eb" },
    purple: { name: "Purple", primary: "#7c3aed" },
    green: { name: "Green", primary: "#16a34a" },
    orange: { name: "Orange", primary: "#ea580c" },
    teal: { name: "Teal", primary: "#0d9488" },
    rose: { name: "Rose", primary: "#e11d48" },
    dark: { name: "Dark", primary: "#f43f5e" },
  };

  // 🔴 UNIFIED THEME OBJECT
  const theme = {
    bg: brandTheme.background,
    background: brandTheme.background, // alias for compatibility
    surface: brandTheme.surface,
    surfaceAlt: isDark ? "#1e293b" : "#f1f5f9",
    border: brandTheme.border,
    text: brandTheme.textPrimary,
    textPrimary: brandTheme.textPrimary,
    textSecondary: brandTheme.textSecondary,
    textMuted: brandTheme.textMuted,
    primary: brandTheme.primary,
    primaryLight: brandTheme.primaryLight || `${brandTheme.primary}25`,
    gradient: brandTheme.primaryGradient || `linear-gradient(135deg, ${brandTheme.primary}, ${brandTheme.primary}dd)`,
    success: "#22c55e",
    warning: "#f59e0b",
    danger: "#ef4444",
  };

  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [previewImage, setPreviewImage] = useState(null);
  const itemsPerPage = 10;

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await getData("chooseus/fetch_all_banner");
      if (response.status) {
        setItems(response.data);
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      alert(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredItems = items.filter(
    (item) =>
      item.title?.toLowerCase().includes(search.toLowerCase()) ||
      item.title2?.toLowerCase().includes(search.toLowerCase()) ||
      item.description?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const paginatedItems = filteredItems.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const toggleHide = async (id, currentHide) => {
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("hide", currentHide === 1 ? 0 : 1);

      const response = await postData("chooseus/update_banner", formData);
      if (response.status) {
        setItems((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, hide: item.hide === 1 ? 0 : 1 } : item
          )
        );
      } else {
        alert(response.message);
      }
    } catch (error) {
      alert(error.message || "An error occurred");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      setItems((prev) => prev.filter((item) => item.id !== id));
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setIsDialogOpen(true);
  };

  const handleView = (item) => {
    alert(
      `📋 Choose Us Details\n\nTitle: ${item.title}\nSubtitle: ${item.title2 || "—"}\nDescription: ${item.description || "—"}\nButton: ${item.button_name || "—"}\nLink: ${item.button_link || "—"}\nStatus: ${item.status === 1 ? "Active" : "Inactive"}\nHide: ${item.hide === 1 ? "Yes" : "No"}`
    );
  };

  const handleAdd = () => {
    setEditingItem(null);
    setIsDialogOpen(true);
  };

  const handleSaveItem = async () => {
    await fetchData();
  };

  const styles = {
    container: {
      background: "transparent",
      fontFamily: "'Inter', 'DM Sans', sans-serif",
      padding: "20px 24px",
      transition: "background 0.3s ease",
    },
  
    header: {
      display: "flex", justifyContent: "space-between", alignItems: "center",
      marginBottom: "24px", flexWrap: "wrap", gap: "16px",
    },
    searchWrapper: { position: "relative", flex: 1, maxWidth: "350px" },
    searchIcon: {
      position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: theme.primary,
    },
    searchInput: {
      width: "100%", padding: "10px 12px 10px 38px", background: theme.background,
      border: `1px solid ${theme.border}`, borderRadius: "10px", fontSize: "13px",
      color: theme.textPrimary, outline: "none", boxSizing: "border-box", transition: "all 0.2s",
    },
    addBtn: {
      display: "flex", alignItems: "center", gap: "6px", padding: "10px 20px",
      background: theme.gradient, color: "#fff", border: "none", borderRadius: "10px",
      fontSize: "13px", fontWeight: 600, cursor: "pointer", transition: "all 0.2s",
      boxShadow: `0 4px 6px -1px ${theme.primary}30`,
    },
    tableWrapper: {
      background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: "12px",
      overflow: "auto", boxShadow: "0 4px 20px rgba(0,0,0,0.05)", transition: "all 0.3s ease",
    },
    table: { width: "100%", borderCollapse: "collapse", minWidth: "1000px" },
    th: {
      padding: "14px 16px", textAlign: "left", fontSize: "12px", fontWeight: 700,
      color: theme.primary, borderBottom: `1px solid ${theme.border}`, background: theme.background,
      whiteSpace: "nowrap", textTransform: "uppercase", letterSpacing: "0.5px",
    },
    td: {
      padding: "14px 16px", fontSize: "13px", color: theme.textPrimary,
      borderBottom: `1px solid ${theme.border}`, verticalAlign: "middle",
    },
    actions: { display: "flex", gap: "6px", flexWrap: "wrap" },
    actionBtn: {
      background: "none", border: "none", cursor: "pointer", padding: "6px",
      color: theme.textMuted, display: "flex", alignItems: "center", justifyContent: "center",
      borderRadius: "6px", transition: "all 0.2s",
    },
    titleCell: { fontWeight: 600, color: theme.textPrimary },
    descriptionCell: { maxWidth: "250px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: theme.textMuted },
    buttonBadge: {
      display: "inline-block", padding: "4px 10px", borderRadius: "6px",
      fontSize: "11px", fontWeight: 500, background: theme.primaryLight, color: theme.primary,
    },
    footer: {
      display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px",
      borderTop: `1px solid ${theme.border}`, background: theme.background, borderRadius: "0 0 12px 12px",
    },
    pageInfo: { fontSize: "12px", color: theme.textMuted },
    pagination: { display: "flex", gap: "6px" },
    pageBtn: (disabled, isActive) => ({
      width: "32px", height: "32px", borderRadius: "6px",
      border: isActive ? `1px solid ${theme.primary}` : `1px solid ${theme.border}`,
      background: isActive ? theme.primaryLight : theme.surface,
      color: isActive ? theme.primary : disabled ? theme.border : theme.textMuted,
      cursor: disabled ? "not-allowed" : "pointer", display: "flex",
      alignItems: "center", justifyContent: "center", transition: "all 0.2s",
    }),
    emptyState: { padding: "60px", textAlign: "center", color: theme.textMuted, fontSize: "14px" },
    loadingState: { padding: "60px", textAlign: "center", color: theme.textMuted, fontSize: "14px" },
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loadingState}>Loading...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
        .image-hover-overlay { opacity: 0; transition: opacity 0.3s; }
        .image-hover-overlay:hover { opacity: 1; }
        .action-btn:hover { background: ${theme.primaryLight}; }
        .view-btn:hover { color: ${theme.success}; }
        .edit-btn:hover { color: ${theme.primary}; }
        .hide-btn:hover { color: ${theme.warning}; }
        .delete-btn:hover { color: ${theme.danger}; }
      `}</style>

      {/* Theme Switcher */}
    

      <div style={styles.header}>
        <div style={styles.searchWrapper}>
          <span style={styles.searchIcon}><SearchIcon /></span>
          <input
            type="text"
            style={styles.searchInput}
            placeholder="Search choose us..."
            value={search}
            onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
            onFocus={(e) => { e.target.style.borderColor = theme.primary; e.target.style.boxShadow = `0 0 0 3px ${theme.primaryLight}`; }}
            onBlur={(e) => { e.target.style.borderColor = theme.border; e.target.style.boxShadow = 'none'; }}
          />
        </div>
        <button style={styles.addBtn} onClick={handleAdd}
          onMouseEnter={(e) => e.currentTarget.style.filter = "brightness(1.1)"}
          onMouseLeave={(e) => e.currentTarget.style.filter = "brightness(1)"}>
          <PlusIcon /> Add
        </button>
      </div>

      <div style={styles.tableWrapper}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>#</th>
              <th style={styles.th}>Main Image</th>
              <th style={styles.th}>Icon</th>
              <th style={styles.th}>Title</th>
              <th style={styles.th}>Subtitle</th>
              <th style={styles.th}>Description</th>
              <th style={styles.th}>Button</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedItems.map((item, index) => (
              <tr key={item.id} style={{ transition: "background 0.2s" }}
                onMouseEnter={(e) => e.currentTarget.style.background = theme.surfaceAlt}
                onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                <td style={styles.td}>
                  <span style={{ color: theme.textMuted, fontSize: "12px" }}>
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </span>
                </td>
                <td style={styles.td}>
                  <ImagePlaceholder imageUrl={item.pic} type="main" onImageClick={setPreviewImage} theme={theme} />
                </td>
                <td style={styles.td}>
                  <ImagePlaceholder imageUrl={item.shortimage} type="short" onImageClick={setPreviewImage} theme={theme} />
                </td>
                <td style={{ ...styles.td, ...styles.titleCell }}>{item.title}</td>
                <td style={styles.td}>{item.title2 || "—"}</td>
                <td style={{ ...styles.td, ...styles.descriptionCell }} title={item.description}>
                  {item.description || "—"}
                </td>
                <td style={styles.td}>
                  {item.button_name ? (
                    <div>
                      <span style={styles.buttonBadge}>{item.button_name}</span>
                      {item.button_link && (
                        <div style={{ fontSize: "10px", color: theme.textMuted, marginTop: "2px", opacity: 0.8 }}>
                          {item.button_link}
                        </div>
                      )}
                    </div>
                  ) : "—"}
                </td>
                <td style={styles.td}>
                  <StatusBadge status={item.status} hide={item.hide} theme={theme} isDark={isDark} />
                </td>
                <td style={styles.td}>
                  <div style={styles.actions}>
                    <button className="action-btn view-btn" style={styles.actionBtn} onClick={() => handleView(item)} title="View Details"><EyeIcon /></button>
                    <button className="action-btn edit-btn" style={styles.actionBtn} onClick={() => handleEdit(item)} title="Edit"><EditIcon /></button>
                    <button className="action-btn hide-btn" style={styles.actionBtn} onClick={() => toggleHide(item.id, item.hide)} title={item.hide === 1 ? "Show" : "Hide"}>
                      {item.hide === 1 ? <ShowIcon /> : <HideIcon />}
                    </button>
                    <button className="action-btn delete-btn" style={styles.actionBtn} onClick={() => handleDelete(item.id)} title="Delete"><DeleteIcon /></button>
                  </div>
                </td>
              </tr>
            ))}
            {paginatedItems.length === 0 && (
              <tr>
                <td colSpan={9} style={styles.emptyState}>No items found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div style={styles.footer}>
        <div style={styles.pageInfo}>
          Showing {paginatedItems.length} of {filteredItems.length} items — Page {currentPage}/{totalPages || 1}
        </div>
        <div style={styles.pagination}>
          <button style={styles.pageBtn(currentPage === 1, false)} onClick={() => setCurrentPage((p) => Math.max(1, p - 1))} disabled={currentPage === 1}>‹</button>
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum;
            if (totalPages <= 5) pageNum = i + 1;
            else if (currentPage <= 3) pageNum = i + 1;
            else if (currentPage >= totalPages - 2) pageNum = totalPages - 4 + i;
            else pageNum = currentPage - 2 + i;
            return pageNum <= totalPages && (
              <button key={pageNum} style={styles.pageBtn(false, currentPage === pageNum)} onClick={() => setCurrentPage(pageNum)}>
                {pageNum}
              </button>
            );
          })}
          <button style={styles.pageBtn(currentPage === totalPages, false)} onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages || totalPages === 0}>›</button>
        </div>
      </div>

      {/* Image Preview Modal */}
      <ImagePreviewModal isOpen={!!previewImage} imageUrl={previewImage} onClose={() => setPreviewImage(null)} />

      {/* Add/Edit Dialog */}
      {isDialogOpen && (
        <AddChooseUsDialog
          onClose={() => { setIsDialogOpen(false); setEditingItem(null); }}
          onSave={handleSaveItem}
          editingItem={editingItem}
          theme={theme}
          isDark={isDark}
        />
      )}
    </div>
  );
};

export default ChooseUs;